export default "__VITE_ASSET__Ck7M2Jp___"